export default {
  name: "Compile"
};